import React from "react"
import ShopReviews from "../../Reviews/ShopReviews"

const Reviews = (shopId) => {
  return (
    <div>
      <ShopReviews shopId={shopId} />
    </div>
  )
}

export default Reviews
